// Module
var code = "<div class=\"condensed remove-top-padding col-xs-12\" ng-show=\"row.changes.length\">\n    <div class=\"auditlog-changes\">\n        <span class=\"tag\" ng-repeat=\"change in row.changes\" ng-bind-html=\"change | auditLogItem:'html'\"></span>\n    </div>\n</div>\n";
// Exports
module.exports = code;